import { Spinner, Typography, Avatar, useDimensions, Icon } from '@telavita-core/react-design-kit'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router'
import instance from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import './AdminReservations.sass'
import clsx from 'clsx'
import ReservationService from 'services/reservation'
import { DayHeader, ReservationListItem } from '../ProfessionalReservations/components'

const AdminReservations = () => {
  const { professional: username } = useParams()
  const { isMobile } = useDimensions()

  const [professional, setProfessional] = useState(null)
  const [reservations, setReservations] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleRefresh = (reservationUuid) => {

    const newReservations = Object.keys(reservations).reduce((prev, curr) => {
      const filteredReservationDay = reservations[curr].filter(reservation => reservation.uuid !== reservationUuid)

      if (filteredReservationDay.length > 0 ) prev[curr] = filteredReservationDay

      return prev
    },{})

    setReservations(newReservations)
  }

  useEffect(() => {
    instance.get(apiEndpoints.PERSON_SLUG(username, 'PSIC'))
      .then(res => {
        const {
          full_name,
          picture_url
        } = res.data.person_general

        const [profile] = res.data.person_profile
        const {
          documents: [{ type_name, value }]
        } = profile
        setProfessional({
          full_name,
          picture_url,
          document: `${type_name} ${value}`
        })
      }).catch(err => {
        console.error(err)
      })
  }, [username])

  useEffect(() => {
    setLoading(true)
    ReservationService.getReservations({ username, isProfessional: true }, true)
      .then(reservations => {
        setLoading(false)
        setReservations(reservations)
      })
      .catch(response => {
        if (response.status === 404) {
          setReservations({})
        }
        setLoading(false)
      })
  }, [username])

  const headerStyles = clsx({
    'AdminReservations__header': true,
    'AdminReservations__header__mobile': isMobile
  })

  const professionalContainerStyles = clsx({
    'AdminReservations__professionalContainer': true,
    'AdminReservations__professionalContainer__mobile': isMobile
  })


  const renderReservations = () => {
    return Object.keys(reservations).map(key => {
      return (
        <div key={key}>
          <DayHeader day={key} />
          {
            reservations[key].map(reservation => (
              <ReservationListItem
                key={reservation.uuid}
                reservation={reservation}
                onRefresh={handleRefresh}
                allowActions={true}
                isAdmin
              />
            ))
          }
        </div>
      )
    })
  }

  return (
    <div className='AdminReservations'>
      <div className={headerStyles}>
        <Typography variant={isMobile ? 'header4' : 'header2'} center={isMobile}>
                    Reservas
        </Typography>
        <div className={professionalContainerStyles}>
          {
            Boolean(professional) &&
                        <div className='AdminReservations__professional'>
                          <Avatar size='regular' alt={professional.full_name} src={professional.picture_url} />
                          <div className='AdminReservations__professional__description'>
                            <Typography variant='content3'>
                                    Psicólogo(a)
                            </Typography>
                            <Typography variant='content3' weight='bolder'>
                              {professional.full_name}
                            </Typography>
                            <Typography variant='content3'>
                              {professional.document}
                            </Typography>
                          </div>
                        </div>
          }
        </div>
      </div>
      <div className='AdminReservations__content'>
        {loading && <div className='AdminReservations__spinnerContainer'><Spinner /></div>}
        {reservations && renderReservations()}
        {
          reservations && Object.keys(reservations).length === 0 &&
                    <div className='ProfessionalReservations__empty'>
                      <Icon
                        name='NoReservation'
                        dimension='medium'
                      />
                      <Typography variant='content2' customClassName='ProfessionalReservations__emptyTitle' weight='bold'>
                            Nenhuma reserva criada pelo profissional
                      </Typography>
                    </div>
        }
      </div>
    </div>
  )
}

export { AdminReservations }
